/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */
/**
 * Useful constants that are used throughout the app.
 */
const constants = {
  /** Peer-to-peer server config. */
  iceServers: [
    // Public servers
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:global.stun.twilio.com:3478?transport=udp' },

    // Private Xirsys server
    { urls: 'stun:ws-turn4.xirsys.com' },
    {
      urls: [
        'turn:ws-turn4.xirsys.com:80?transport=udp',
        'turn:ws-turn4.xirsys.com:3478?transport=udp',
        'turn:ws-turn4.xirsys.com:80?transport=tcp',
        'turn:ws-turn4.xirsys.com:3478?transport=tcp',
        'turns:ws-turn4.xirsys.com:443?transport=tcp',
        'turns:ws-turn4.xirsys.com:5349?transport=tcp'
      ],
      username:
        'ByFitRqfy1ibiEQyY9A3-uOkzb0FD1Ygo31Q9wPF5iMjY58VH_N1QqlMg4DFNr7pAAAAAGM_GF12YXRvbWluYw==',
      credential: '23099f72-45a1-11ed-8259-0242ac140004'
    }
  ]
}

export default constants
